import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Modal, ModalBody } from 'reactstrap';
import api from '../../api/api';

import './UploadImages.css';
import ModalDeleteImages from './ModalDeleteImages';

class UploadImages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imagenes: props.imagenes || [],
            selectedImagen: 0,
            isOpen: false,
        }
    }

    componentDidUpdate(prevProps) {
        const { imagenes } = this.props;
        if (prevProps.imagenes !== imagenes) {
            this.setState({ imagenes });
        }
    }

    onImageDrop = imagenes => {
        imagenes = imagenes || [];
        this.setState(
            prevState => ({
                imagenes: prevState.imagenes.concat(imagenes.map(im => ({ imagen: im })))
            }),
            () => this.props.onChange(this.state.imagenes)
        );
    }

    onDelete = order => {
        this.setState(
            prevState => {
                prevState.imagenes.splice(order, 1);
                return {
                    imagenes: prevState.imagenes
                }
            },
            () => this.props.onChange(this.state.imagenes)
        );
    }

    render() {
        const { imagenes, selectedImagen } = this.state;

        const imagenModal = selectedImagen < imagenes.length ? imagenes[selectedImagen] : '';
        return (
            <div className="upload-images">
                {
                    imagenes.map((imagen, i) =>
                        <div className="position-relative" key={i}>
                            <img
                                className="upload-images__image ui-clickable-image"
                                src={(imagen.imagen && imagen.imagen.preview) || (api.BASE_URL + imagen.imagen)}
                                onClick={e => this.setState(prevState => ({ selectedImagen: i, isOpen: !prevState.isOpen }))}
                            />
                            {
                                !this.props.disabled &&
                                <ModalDeleteImages order={i} onDelete={this.onDelete} />
                            }
                        </div>
                    )
                }
                <Modal className="ui-paradigma-modal ui-image-preview-modal" toggle={() => this.setState(prevState => ({ isOpen: !prevState.isOpen }))} isOpen={this.state.isOpen}>
                    <ModalBody>
                        <img src={(imagenModal.imagen && imagenModal.imagen.preview) || (api.BASE_URL + imagenModal.imagen)} />
                    </ModalBody>
                </Modal>
                {
                    (imagenes.length === 0) &&
                    this.props.disabled &&
                    <p className="ui-empty-state">No hay imágenes</p>
                }
                {
                    !this.props.disabled &&
                    <Dropzone
                        multiple={false}
                        accept="image/*"
                        className="dropzone"
                        onDrop={this.onImageDrop}
                    >
                        <p>Agregue una nueva imagen</p>
                    </Dropzone>
                }
            </div>
        );
    }
}

export default UploadImages;



// WEBPACK FOOTER //
// ./src/views/Loteos/UploadImages.js